import ReduxSagaFirebase from 'redux-saga-firebase';
import { MyCookAroundFirebase } from '../constants/firebase';
import { AuthSaga } from './auth/saga';
import { MealSaga } from './meals/saga';
import { UserSaga } from './user/saga';
import { OrderSaga } from './orders/saga';
import { CooksProfileMealSaga } from './cooksprofile/saga';
import { SettingsSaga } from './settings/saga';
import { ChatSaga } from './chat/saga';
import { AdminSaga } from './admin/saga';
import { NotificationSaga } from './notifications/saga';
import { PaymentSaga } from './bank/saga';
import { paymentCustomerSaga } from './payment/saga';
// * import sagas here

export const MCAFirebaseSaga = new ReduxSagaFirebase(MyCookAroundFirebase);

// * include imported sagas here
export const sagas = [
  AuthSaga,
  MealSaga,
  UserSaga,
  OrderSaga,
  CooksProfileMealSaga,
  SettingsSaga,
  ChatSaga,
  AdminSaga,
  NotificationSaga,
  PaymentSaga,
  paymentCustomerSaga,
];
